export default __webpack_public_path__ + "static/media/kingcasino-crown.73b51414.png";